import { render, staticRenderFns } from "./QuotesListPage.vue?vue&type=template&id=531f627a&scoped=true"
import script from "./QuotesListPage.vue?vue&type=script&lang=ts"
export * from "./QuotesListPage.vue?vue&type=script&lang=ts"
import style0 from "./QuotesListPage.vue?vue&type=style&index=0&id=531f627a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f627a",
  null
  
)

export default component.exports